import { createSlice } from '@reduxjs/toolkit';

const initalState: {
  timezone: string;
} = {
  timezone: 'Asia/Calcutta'
};

const preferences = createSlice({
  name: 'preferences',
  initialState: initalState,
  reducers: {
    setPreferences: (state, action) => {
      return { ...state, ...action.payload };
    }
  }
});

export const { setPreferences } = preferences.actions;
export default preferences.reducer;
